import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { httpClient } from '../core';
import { env } from '@/env';
import { Model } from '@/models/model.model';

export interface ModelsState {
  models: Model[];
  isFetchingModels: boolean;
}

export const state: ModelsState = {
  models: [],
  isFetchingModels: false
};

export const getters: GetterTree<ModelsState, any> = {
  getModels: () => {
    return state.models;
  },
  isFetchingModels: () => {
    return state.isFetchingModels;
  }
};

export const mutations: MutationTree<ModelsState> = {
  SET_MODELS(stateParam, dictionariesParam) {
    stateParam.models = dictionariesParam;
    stateParam.isFetchingModels = true;
  },
  SET_FETCHING_MODELS(stateParam) {
    stateParam.isFetchingModels = true;
  },
  UNSET_FETCHING_MODELS(stateParam) {
    stateParam.isFetchingModels = false;
  },
  RESET_STATE(stateParam) {
    stateParam.models = [];
  }
};

export const actions: ActionTree<ModelsState, any> = {
  fetchModels: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_FETCHING_MODELS');
      httpClient.instance
        .get(`${env.apiUrl}/languages/${env.applicationId}/models`)
        .then(modelsResponse => {
          commit('SET_MODELS', modelsResponse.data);
          resolve(modelsResponse);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error('Error fetching models ' + error);
          reject(error);
        })
        .finally(() => {
          commit('UNSET_FETCHING_MODELS');
        });
    });
  },
  resetModelsState: ({ commit }) => {
    commit('RESET_STATE');
  }
};

export const model: Module<ModelsState, any> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
